export default {"src":"/_next/static/media/StagePlayer.0b266595.svg","height":24,"width":24};